export default "__VITE_ASSET__SFZ0vosy__"